import { useEffect } from 'react';
import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import Organizations from 'containers/Organizations';
import {
  getSelectedOrganizationId,
  useSelectedOrganizationId,
} from 'stores/useAuthStore';

function RootIndex() {
  const router = useRouter();
  const hasOrg = Number.isFinite(useSelectedOrganizationId());

  useEffect(() => {
    if (hasOrg) router.navigate({ to: '/dashboard', replace: true });
  }, [hasOrg, router]);

  return hasOrg ? null : <Organizations />;
}

export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: () => {
    if (Number.isFinite(getSelectedOrganizationId())) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: RootIndex,
});
